import { useState, useContext } from 'react';
import { LanguageContext } from '../../context/LanguageContext';
import languages from '../../data/languages';
import './MobileTranslationBtn.scss';

function MobileTranslationBtn() {
    let { languageIndex, toggleLanguage } = useContext(LanguageContext);
    let [open, setOpen] = useState(false);

    function toggleOpen(){
        setOpen(!open);
    }

    return (
        <div className='mobile-translation-btn' onClick={ toggleOpen }>
            <span>{ !languageIndex ? 'IDIOMA' : 'LANGUAGE' }</span>

            {open && (
                <ul>{languages.map((item, index) => 
                    <li key={index} onClick={toggleLanguage}>
                        <img src={item.img} alt={item.alt} />
                        {item.language}
                    </li>
                )}</ul>
            )}
        </div>
    )
}

export default MobileTranslationBtn;